import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ScavengerHuntPage = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [marketing, setMarketing] = useState(true); // Default checked
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !name) {
      setError('Please fill in all required fields');
      return;
    }
    
    if (!marketing) {
      setError('Please agree to receive marketing emails to participate');
      return;
    }
    
    if (!termsAccepted) {
      setError('You must accept the Terms & Conditions to participate');
      return;
    }
    
    try {
      setError('');
      
      // Send data to your backend API
      const response = await fetch('/api/hunt/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, name, marketing }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }
      
      // Show success message
      setSubmitted(true);
      
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again later.');
      console.error('Error submitting form:', err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900">
      {/* Header */}
      {/* <header className="bg-black py-4">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center text-white">
              <img src="/logo.png" alt="BoxyQR Logo" className="h-10 mr-2" />
              <span className="text-xl font-bold">BoxyQR</span>
            </Link>
            <Link to="/" className="text-white hover:opacity-80 transition-opacity font-medium">
              Return to Home
            </Link>
          </div>
        </div>
      </header> */}

      {/* Hero Section */}
      <section className="py-16 text-center bg-gradient-to-r from-gray-900 to-black text-white mt-0 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container mx-auto  px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-extrabold mt-10 mb-10">🔍 SCAN. SOLVE. SCORE $500. 🔍</h1>
            <h2 className="text-2xl md:text-2xl font-bold mb-3">THE GREAT BOXYQR TREASURE HUNT</h2>
            <p className="text-xl font-bold mb-10">
              There's $500 cash hidden somewhere in San Francisco... and only our QR codes know where.
            </p>
            <div className="inline-block bg-white bg-opacity-20 py-4 px-6 mb-10 rounded-md">
              <p className="text-lg font-semibold">Hunt Begins: Announced on Instagram</p>
            </div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full lg:w-1/2 px-4 mb-10 lg:mb-0">
              <h2 className="text-2xl font-bold mb-8 pb-2 border-b-2 border-black">HOW IT WORKS</h2>
              <div className="space-y-6">
              <div className="flex items-start">
                  <div className="w-10 h-10 bg-black text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0 mr-4">
                    1
                  </div>
                  <p className="text-xl mt-1 font-medium mb-1"> Follow on Instagram, the start date will be announced the night before.</p>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-black text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0 mr-4">
                    2
                  </div>
                  <p className="text-xl mt-1 font-medium mb-1"> The next morning you will recieve an email with the starting QR code clue to scan (Sent at 9:45 AM)</p>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-black text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0 mr-4">
                    3
                  </div>
                  <p className="text-xl mt-1 font-medium mb-1"> Solve the riddle to find the next location</p>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-black text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0 mr-4">
                    4
                  </div>
                  <p className="text-xl mt-1 font-medium mb-1"> Hunt through iconic SF spots, scanning BoxyQR codes at each stop</p>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-black text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0 mr-4">
                    5
                  </div>
                  <p className="text-xl mt-1 font-medium mb-1"> Be the first to reach the final destination and claim your prize!</p>
                </div>
              </div>
            </div>
            
            <div className="w-full lg:w-1/2 px-4">
              <h2 className="text-2xl font-bold mb-8 pb-2 border-b-2 border-black">WHY THIS IS EPIC</h2>
              <ul className="text-xl space-y-4 list-disc pl-5">
                <li>Experience the speed and reliability of BoxyQR scanning in real-world conditions</li>
                <li>Discover hidden gems throughout San Francisco</li>
                <li>Compete against fellow treasure hunters in real-time</li>
                <li>Show off your problem-solving skills and city knowledge</li>
                <li>Win actual cash... not just a discount code!</li>
                <li>Share your journey #boxyqr!</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Registration Section */}
      <section className="py-16 bg-gray-50 mt-0 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container mx-auto px-4">
          {!submitted ? (
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-6">REGISTER TO PARTICIPATE</h2>
              <p className="mb-8 text-lg">
                Sign up now to receive the first clue directly to your inbox the hunt will be announced the night before on out Instagram and follow us on Instagram for real-time updates during the hunt!
              </p>
              <form className="text-left" onSubmit={handleSubmit}>
                <div className="mb-6">
                  <label htmlFor="name" className="block font-semibold mb-2">Full Name*</label>
                  <input 
                    type="text" 
                    id="name" 
                    value={name} 
                    onChange={(e) => setName(e.target.value)} 
                    placeholder="Enter your name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    required
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="email" className="block font-semibold mb-2">Email Address*</label>
                  <input 
                    type="email" 
                    id="email" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)} 
                    placeholder="Enter your email address"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    required
                  />
                </div>
                <div className="mb-6 flex items-start">
                  <input 
                    type="checkbox" 
                    id="marketing" 
                    checked={marketing} 
                    onChange={(e) => setMarketing(e.target.checked)} 
                    className="mt-1 mr-3"
                  />
                  <label htmlFor="marketing" className="flex-1">
                    Yes, I agree to receive marketing emails from BoxyQR about future events and promotions
                  </label>
                </div>
                <div className="mb-6 flex items-start">
                  <input 
                    type="checkbox" 
                    id="terms" 
                    checked={termsAccepted} 
                    onChange={(e) => setTermsAccepted(e.target.checked)} 
                    className="mt-1 mr-3"
                  />
                  <label htmlFor="terms" className="flex-1">
                    I am 18 years of age or older and I agree to the{' '}
                    <button 
                      type="button" 
                      className="text-blue-600 underline focus:outline-none"
                      onClick={() => setShowTerms(true)}
                    >
                      Terms & Conditions
                    </button>
                  </label>
                </div>
                {error && <div className="text-red-600 mb-6">{error}</div>}
                <button 
                  type="submit" 
                  className="w-full bg-black text-white font-semibold py-3 px-6 rounded-md hover:bg-gray-800 transition-colors"
                >
                  Register Now
                </button>
              </form>
              <div className="mt-10">
                <p>Follow us on Instagram for live updates during the hunt:</p>
                <a 
                  href="https://instagram.com/BoxyQR" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center mt-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 px-6 rounded-md hover:opacity-90 transition-opacity"
                >
                  <span className="mr-2">📸</span> @BoxyQR
                </a>
              </div>
            </div>
          ) : (
            <div className="max-w-2xl mx-auto text-center bg-green-50 p-8 rounded-lg">
              <h2 className="text-2xl font-bold text-green-800 mb-4">You're All Set!</h2>
              <p className="mb-2">Thanks for registering for the BoxyQR Scavenger Hunt!</p>
              <p className="mb-6">Don't forget to follow us on Instagram <a href="https://instagram.com/BoxyQR" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">@BoxyQR</a> for live updates and the first clue.</p>
              <div className="mt-8">
                <p className="font-medium mb-3">Spread the word and invite your friends:</p>
                <div className="flex flex-col sm:flex-row justify-center gap-3">
                  <button className="bg-blue-400 text-white py-2 px-6 rounded-md hover:bg-blue-500 transition-colors">Tweet</button>
                  <button className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition-colors">Share</button>
                  <button 
                    className="bg-gray-200 text-gray-800 py-2 px-6 rounded-md hover:bg-gray-300 transition-colors"
                    onClick={() => {
                      navigator.clipboard.writeText('https://app.boxyqr.com/hunt');
                      alert('Link copied to clipboard!');
                    }}
                  >
                    Copy Link
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">FREQUENTLY ASKED QUESTIONS</h2>
          <div className="max-w-3xl mx-auto">
            <div className="mb-8 pb-6 border-b border-gray-200">
              <h3 className="text-xl font-semibold mb-3">Do I need to create an account with BoxyQR to participate?</h3>
              <p className="text-gray-700">No, our QR codes can be scanned with any smartphone camera.</p>
            </div>
            <div className="mb-8 pb-6 border-b border-gray-200">
              <h3 className="text-xl font-semibold mb-3">Is this hunt open to everyone?</h3>
              <p className="text-gray-700">Yes! Anyone over 18 years of age can participate, but you must be physically in San Francisco to complete the hunt.</p>
            </div>
            <div className="mb-8 pb-6 border-b border-gray-200">
              <h3 className="text-xl font-semibold mb-3">What if someone finds the treasure before me?</h3>
              <p className="text-gray-700">We'll announce immediately on Instagram once the treasure has been found. We may also have some surprise secondary prizes!</p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl font-semibold mb-3">How difficult are the clues?</h3>
              <p className="text-gray-700">The clues are challenging but solvable with some local knowledge and creative thinking. We want to make sure it's fun for everyone!</p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl font-semibold mb-3">Will it be limited to one area?</h3>
              <p className="text-gray-700">All clues will be posted within a 3 mile radius.</p>
            </div>
            <div className="mb-8">
              <h3 className="text-xl font-semibold mb-3">How many clues will there be?</h3>
              <p className="text-gray-700">There will be five to seven clues and several different hunts all leading to the final prize.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Terms and Conditions Modal */}
      {showTerms && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 p-4">
          <div className="bg-white w-full max-w-4xl max-h-[90vh] rounded-lg overflow-y-auto">
            <div className="p-6 md:p-8">
              <h2 className="text-2xl font-bold mb-6">Terms & Conditions</h2>
              <div className="prose max-w-none mb-6">
                <h3 className="text-lg font-semibold mt-6">PARTICIPATION AGREEMENT</h3>
                <p><strong>AGE REQUIREMENT:</strong> By participating in the BoxyQR Scavenger Hunt, you confirm that you are 18 years of age or older.</p>
                
                <h3 className="text-lg font-semibold mt-6">ASSUMPTION OF RISK</h3>
                <p>Participation in the BoxyQR Scavenger Hunt involves physical activity in public spaces throughout San Francisco. By participating, you acknowledge and agree that:</p>
                <ul className="list-disc pl-5 mb-4">
                  <li>You are voluntarily participating in this event with knowledge of the inherent risks, hazards, and dangers involved.</li>
                  <li>You assume all risks associated with your participation, including but not limited to:
                    <ul className="list-disc pl-5 mt-2">
                      <li>Physical injuries (including serious injury or death)</li>
                      <li>Property damage or loss</li>
                      <li>Adverse weather conditions</li>
                      <li>Interactions with other participants or members of the public</li>
                      <li>Traffic hazards</li>
                      <li>Crime or civil unrest</li>
                      <li>Any other risks associated with outdoor activities in an urban environment</li>
                    </ul>
                  </li>
                </ul>
                
                <h3 className="text-lg font-semibold mt-6">WAIVER AND RELEASE OF LIABILITY</h3>
                <p>By participating in the BoxyQR Scavenger Hunt, you hereby RELEASE, WAIVE, DISCHARGE, AND COVENANT NOT TO SUE BoxyQR, its parent companies, subsidiaries, affiliates, officers, servants, agents, employees, and all other persons or entities associated with the event (hereinafter referred to as "RELEASEES") from any and all liability, claims, demands, actions, and causes of action whatsoever arising out of or related to any loss, damage, or injury, including death, that may be sustained by you, or to any property belonging to you, while participating in the Scavenger Hunt or while in, on or upon the premises where the event is being conducted.</p>
                
                <h3 className="text-lg font-semibold mt-6">INDEMNIFICATION</h3>
                <p>You agree to INDEMNIFY AND HOLD HARMLESS the RELEASEES from any loss, liability, damage, or costs, including court costs and attorney's fees, that they may incur due to your participation in the Scavenger Hunt.</p>
                
                <h3 className="text-lg font-semibold mt-6">CONDUCT AND SAFETY</h3>
                <p>You agree to:</p>
                <ul className="list-disc pl-5 mb-4">
                  <li>Follow all applicable laws, rules, and regulations while participating</li>
                  <li>Respect private property and not trespass</li>
                  <li>Behave in a respectful and courteous manner toward others</li>
                  <li>Not engage in any dangerous, illegal, or disruptive behavior</li>
                  <li>Not be under the influence of alcohol or drugs while participating</li>
                  <li>Follow all traffic laws and practice pedestrian safety</li>
                </ul>
                
                <h3 className="text-lg font-semibold mt-6">MEDIA RELEASE</h3>
                <p>You grant BoxyQR the right to take photographs or videos of you in connection with the Scavenger Hunt and to use such media for promotional purposes without compensation.</p>
                
                <h3 className="text-lg font-semibold mt-6">PRIZE ELIGIBILITY</h3>
                <p>To claim the prize, you must:</p>
                <ul className="list-disc pl-5 mb-4">
                  <li>Be the first participant to complete all steps of the scavenger hunt</li>
                  <li>Provide valid identification confirming you are 18 years or older</li>
                  <li>Complete any required tax documentation</li>
                </ul>
                <p>BoxyQR reserves the right to disqualify any participant who violates these terms or engages in fraudulent activity.</p>
                
                <h3 className="text-lg font-semibold mt-6">PRIVACY</h3>
                <p>Information collected during registration will be used in accordance with BoxyQR's Privacy Policy. By participating, you consent to:</p>
                <ul className="list-disc pl-5 mb-4">
                  <li>Collection and use of your personal information for event administration</li>
                  <li>Receiving event-related communications</li>
                  <li>If selected, use of your name and likeness for promotional purposes</li>
                </ul>
                
                <h3 className="text-lg font-semibold mt-6">CANCELLATION POLICY</h3>
                <p>BoxyQR reserves the right to cancel, postpone, or modify the event due to weather, safety concerns, or other factors beyond our control, without liability.</p>
                
                <h3 className="text-lg font-semibold mt-6">GOVERNING LAW</h3>
                <p>These terms shall be governed by the laws of the State of California.</p>
                
                <h3 className="text-lg font-semibold mt-6">SEVERABILITY</h3>
                <p>If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will remain in full force and effect.</p>
                
                <p className="font-bold mt-6">BY CHECKING THE BOX INDICATING YOUR ACCEPTANCE OF THESE TERMS, YOU ACKNOWLEDGE THAT YOU HAVE READ THIS AGREEMENT, UNDERSTAND IT, AND AGREE TO BE BOUND BY ITS TERMS AND CONDITIONS.</p>
              </div>
            </div>
            <div className="px-6 pb-6 flex justify-center">
              <button 
                className="bg-black text-white font-semibold py-3 px-8 rounded-md hover:bg-gray-800 transition-colors"
                onClick={() => setShowTerms(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      {/* <footer className="bg-black text-white py-10">
        <div className="container mx-auto px-4 text-center">
          <div className="flex justify-center items-center mb-4">
            <img src="/logo.png" alt="BoxyQR Logo" className="h-8 mr-2" />
            <span className="font-bold">BoxyQR</span>
          </div>
          <p className="max-w-lg mx-auto mb-6">Transforming how the world connects with QR technology that actually works.</p>
          <div className="mb-6">
            <Link to="/" className="text-white mx-4 hover:opacity-80 transition-opacity">Home</Link>
            <Link to="/privacy" className="text-white mx-4 hover:opacity-80 transition-opacity">Privacy Policy</Link>
            <Link to="/terms" className="text-white mx-4 hover:opacity-80 transition-opacity">Terms of Service</Link>
          </div>
          <p className="text-sm opacity-70">© 2025 BoxyQR. All rights reserved.</p>
        </div>
      </footer> */}
    </div>
  );
};

export default ScavengerHuntPage;